module.exports = __webpack_public_path__ + "static/media/keeping_itreal.e845a9bc.svg";